import { FormattedMessage, useIntl } from 'react-intl';
import { JSX, ReactNode } from 'react';

import { useStyles } from './join-section.styles';
import { ContentWrapper } from '../../../common/content-wrapper';
import { SectionTitle } from '../../../common/section-title';
import { joinItems, joinItemsUa } from './join.items';
// @ts-ignore
import joinImg from '../../../../assets/images/join/join.jpg';
import { Button } from '../../../common/button';
import { Locales, SectionLabels } from '../../../../constants/common-constants';
import { useLocale } from '../../../../context';

export const JoinSection = (): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();
  const id = SectionLabels.join;
  const { locale } = useLocale();
  const items = locale === Locales.en ? joinItems : joinItemsUa;

  return (
    <section
      className={classes.root}
      data-testid="principles"
      aria-labelledby={id}
    >
      <ContentWrapper externalStyles={classes.contentStyles}>
        <SectionTitle
          id={id}
          colorPart="join.title-1"
          title="join.title-2"
          content="join.content"
          isTitleLineBreak
        />
        <div className={classes.stepsWrapper}>
          <div className={classes.imageWrapper}>
            <img width={628} height={898} className={classes.img} src={joinImg} alt="" aria-hidden="true" />
          </div>
          <div>
            <ul className={classes.list}>
              {items.map(item => (
                <li key={item.title} className={classes.listItem}>
                  <h3 className={classes.listItemTitle}><FormattedMessage id={item.title} /></h3>
                  {item.content.map((itemContent, index) => (
                    <p className={classes.listItemContent} key={index}>
                      {intl.formatMessage(
                        { id: itemContent },
                        { a: (chunk: ReactNode) => (
                            <a
                              className={classes.link}
                              href={intl.formatMessage({ id: item.link })}
                              target="_blank"
                              rel="noopener noreferrer"
                              aria-label={intl.formatMessage({ id: item.linkAriaLabel })}
                            >
                              {chunk}
                            </a>
                        ) },
                      )}
                    </p>
                  ))}
                </li>
              ))}
            </ul>
            {locale === Locales.en && <h4 className={classes.disclaimer}><FormattedMessage id="join.disclaimer.title" /></h4>}
            <p className={classes.disclaimer}><FormattedMessage id="join.disclaimer" /></p>
          </div>
        </div>
        <div className={classes.ctaWrapper}>
          <p className={classes.cta}>
            <FormattedMessage id="join.cta" />
          </p>
          <Button
            variant="dark"
            to={intl.formatMessage({ id: 'join.link', defaultMessage: '' })}
            isExternal
            ariaLabel="joinCharter.cta.ariaLabel"
          >
            <FormattedMessage id="joinCharter.cta" />
          </Button>
        </div>
      </ContentWrapper>
    </section>
  );
};
